import Script from 'next/script'

/**
 * Cookie 插件
 */
const Tawkto = () => {
  return (
    <Script
      id="tawkto-script"
      strategy="afterInteractive"
      src="https://embed.tawk.to/682b6c8d8ec535190f11f082/1irkq033n"
      crossOrigin="anonymous"
    />
  )
}

export default Tawkto
